import VerifyLogin from '@pages/VerifyLogin.vue'
import VerifySignUp from '@pages/VerifySignUp.vue'

export default [
  {
    path: '/email/logged-in/',
    name: 'VerifyLogin',
    component: VerifyLogin,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: (_, to) => to.query.access_token && to.query.refresh_token,
          redirect: 'Home'
        }
      ],
      flexContainer: true,
      hideNav: true,
      noBodyBackground: true
    }
  },
  {
    path: '/auth/approved/:uid-:key',
    name: 'VerifySignUp',
    component: VerifySignUp,
    meta: {
      flexContainer: true,
      hideNav: true,
      noBodyBackground: true
    }
  }
]
